/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jade_Sharp_Owl_FawnInputs */

const en_jade_sharp_owl_fawn = /** @type {(inputs: Jade_Sharp_Owl_FawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments Available`)
};

const de_jade_sharp_owl_fawn = /** @type {(inputs: Jade_Sharp_Owl_FawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare verfügbar`)
};

/**
* | output |
* | --- |
* | "Comments Available" |
*
* @param {Jade_Sharp_Owl_FawnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const jade_sharp_owl_fawn = /** @type {((inputs?: Jade_Sharp_Owl_FawnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jade_Sharp_Owl_FawnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jade_sharp_owl_fawn(inputs)
	return de_jade_sharp_owl_fawn(inputs)
});